<template>
    <div class="col status-col" :data-title="statusTitle">
        <span :style="statuses[status].color" v-if="status < 6"></span>
        <component v-else :is="statuses[status].component" v-bind:key="Math.random()"/>
    </div>
</template>

<script>

    import IconCanceledByMarlink from "../common/icons/EventStatus/IconCanceledByMarlink";
    import IconCanceledByCustomer from "../common/icons/EventStatus/IconCanceledByCustomer";
    import IconCanceledByInmarsat from "../common/icons/EventStatus/IconCanceledByInmarsat";
    import IconNotConfirmedByInmarsat from "../common/icons/EventStatus/IconNotConfirmedByInmarsat";
    import IconSuccessful from "../common/icons/EventStatus/IconSuccessful";
    import {markRaw} from "vue"

    export default {
        name: 'event-status',

        components: {
            IconSuccessful,
            IconNotConfirmedByInmarsat,
            IconCanceledByInmarsat,
            IconCanceledByMarlink,
            IconCanceledByCustomer
        },

        props: {
            status: Number,
            statusTitle: String
        },

        data() {
            return {
                statuses: {
                    1: {
                        color: "background: #EA3811;",
                        title: "No confirmation received"
                    },
                    2: {
                        color: "background: #FA9145;",
                        title: "Pending confirmation"
                    },
                    5: {
                        color: "background: #00AF41;",
                        title: "Confirmation received"
                    },
                    6: {
                        component: markRaw(IconCanceledByCustomer),
                        title: "Canceled by Customer"
                    },
                    7: {
                        component: markRaw(IconCanceledByMarlink),
                        title: "Canceled by Marlink"
                    },
                    8: {
                        component: markRaw(IconCanceledByInmarsat),
                        title: "Canceled by Inmarsat"
                    },
                    9: {
                        component: markRaw(IconNotConfirmedByInmarsat),
                        title: "Not confirmed by Inmarsat"
                    },
                    10: {
                        component: markRaw(IconSuccessful),
                        title: "Successful"
                    }

                }
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
